import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { ListRequirements, ItensRequirements, Form } from "./styles";
import { Col, Container, Content, HeaderContent, Title } from "../../OnboardForgotPassword/styles";

import { changePasswordAfterValidate } from "../../../store/modules/recoverPassword/actions";

import alertIcon from "../../../assets/alert-outline.svg";
import checkIcon from "../../../assets/check-icon.svg";

import { Button, Input } from "../../../shared/components";

const schema = yup
	.object({
		password: yup
			.string()
			.required("Senha é obrigatória")
			.min(8, "")
			.matches(/[a-z]/, `${"\u200B"}`)
			.matches(/[A-Z]/, `${"\u200B"}`)
			.matches(/\D/, `${"\u200B"}`)
			.matches(/[^A-Za-z0-9]/, `${"\u200B"}`)
			.matches(/^(?=.*\d)(?!.*(?:012|123|234|345|456|567|678|789|890))/, `${"\u200B"}`),
		password_confirm: yup
			.string()
			.oneOf([yup.ref("password")], "As senhas devem coincidir")
			.required("Confirme sua senha"),
	})
	.required();

export default function ChangePassword() {
	const dispatch = useDispatch();

	const { token, loading } = useSelector((state) => state.recoverPassword);

	const [hidePass, setHidePass] = useState({
		new: true,
		confirm: true,
	});
	const [passControl, setPassControl] = useState({
		password: false,
		password_confirm: false,
	});

	const {
		register,
		watch,
		handleSubmit,
		trigger,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		mode: "onChange",
		reValidateMode: "onSubmit",
	});

	const { password, password_confirm } = watch();

	useEffect(() => {
		const { unsubscribe } = watch((value, { name }) => {
			setPassControl((prev) => ({
				...prev,
				[name]: Boolean(value[name].length),
			}));
		});

		return () => unsubscribe();
	}, []);

	useEffect(() => {
		if (password && password_confirm.length) trigger("password_confirm");
		if (password_confirm && password.length) trigger("password");
	}, [password, password_confirm]);

	const handleVisibilityPassword = useCallback(
		/**
		 * @param { "new" | "confirm"} field
		 */
		(field) => {
			setHidePass((prev) => ({
				...prev,
				[field]: !prev[field],
			}));
		},
		[]
	);

	const submit = (data) => {
		const { password, password_confirm } = data;
		dispatch(changePasswordAfterValidate(token, password, password_confirm));
	};
	console.log(errors);

	return (
		<Container>
			<Content>
				<HeaderContent>
					<Title>Crie sua nova senha</Title>
				</HeaderContent>
				<Form onSubmit={handleSubmit(submit)}>
					<Col className="gap-4">
						<Input
							label="Senha"
							fieldRegister="password"
							placeholder="Insira sua senha"
							register={register}
							required={true}
							type={hidePass.new ? "password" : "text"}
							errorMessage={errors.password}
						>
							<Button
								btnType="icon"
								type="button"
								icons={
									hidePass.new
										? "MdVisibility"
										: "MdVisibilityOff"
								}
								onClick={() =>
									handleVisibilityPassword(
										"new"
									)
								}
								tabIndex={-1}
							/>
						</Input>

						<CheckControl
							password={
								password && password.length
									? password
									: ""
							}
						/>

						<Input
							label="Confirme a Senha"
							fieldRegister="password_confirm"
							placeholder="Insira sua senha"
							register={register}
							required={true}
							type={hidePass.confirm ? "password" : "text"}
							errorMessage={errors.password_confirm}
						>
							<Button
								btnType="icon"
								type="button"
								icons={
									hidePass.confirm
										? "MdVisibility"
										: "MdVisibilityOff"
								}
								onClick={() =>
									handleVisibilityPassword(
										"confirm"
									)
								}
								tabIndex={-1}
							/>
						</Input>
					</Col>

					<Button
						title="Salvar nova senha"
						type="submit"
						disabled={
							!Object.values(passControl).every(
								(item) => item
							) || Object.keys(errors).length
						}
						loading={loading}
					/>
				</Form>
			</Content>
		</Container>
	);
}

const CheckControl = ({ password }) => {
	const requirements = useMemo(
		() => [
			{ label: "8 caracteres", test: (value) => value && value.length >= 8 },
			{ label: "1 letra minúscula", test: (value) => /[a-z]/.test(value) },
			{ label: "1 letra maiúscula", test: (value) => /[A-Z]/.test(value) },
			{ label: "1 número", test: (value) => /\d/.test(value) },
			{ label: "1 caractere especial", test: (value) => /[^A-Za-z0-9]/.test(value) },
			{
				label: "A senha não pode ter sequência númerica. Ex: 123, 234.",
				test: (value) =>
					/^(?=.*\d)(?!.*(?:012|123|234|345|456|567|678|789|890))/.test(value),
			},
		],
		[]
	);

	const list = useMemo(
		() => requirements.map((item) => ({ ...item, isValid: item.test(password) })),
		[password, requirements]
	);

	return (
		<ListRequirements>
			{list.map((req, index) => {
				return (
					<ItensRequirements key={index}>
						<img
							src={req.isValid ? checkIcon : alertIcon}
							alt={req.isValid ? "check icon" : "alert icon"}
						/>
						{req.label}
					</ItensRequirements>
				);
			})}
		</ListRequirements>
	);
};
